module.exports = __webpack_public_path__ + "static/media/Silver-Coteau-Palmer.5583f60e.jpg";